import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import CookieBanner from "@/components/CookieBanner";
import CalculatorPage from "@/pages/CalculatorPage";
import DashboardPage from "@/pages/DashboardPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import FrontaliersPage from "@/pages/FrontaliersPage";
import EmbedPage from "@/pages/EmbedPage";
import LegalPage from "@/pages/LegalPage";
import PrivacyPage from "@/pages/PrivacyPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          {/* Embed has no shared Layout (chrome-free for iframes) */}
          <Route path="/embed" element={<EmbedPage />} />
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<CalculatorPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/frontaliers" element={<FrontaliersPage />} />
                <Route path="/legal" element={<LegalPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
              </Routes>
              <CookieBanner />
            </Layout>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
